"use strict";

App.Pages.Stellas = class Stellas extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/stellas',
			nameRu: 'Стелы',
		};
	}

	static get template()
	{
		//language=HTML
		return `
		<div class="page navbar-fixed">

			<div class="page-content">

				<div class="page-header">
					<h3>Стелы</h3>
				</div>
				
				<div class="stretch-block">
					<div class="content card" pf="listContent" style="margin:0;">
					<div class="list" pf="list"></div>
					</div>
				</div>

			</div>

		</div>

		`;
	}

	init()
	{
		super.init();

		this.list = new PF.ListCrud({
			dom: {
				element: this.dom.list,
				scrollTarget: this.dom.pageContent
			},
			newItemData: { serverVa: { screens: [], cameras: [] } },
			searchable: true,
			modelsConfig: {
				represent: 'stella/manage',
				limit: 20,
			},
			itemClass: Stella,
			searchConfig: ' @{name} ~ @{list.searchField} || @{address} ~ @{list.searchField} || @{serverVa.ip} ~ @{list.searchField}'
		});
	}
};

class Stella extends PF.ListCrud.Item
{
	static get options()
	{
		return {
			title: `@{model.name}`,
			newTitle: `Добавить стелу`,
			formConfig: {
				fieldsConfig: {
					name: {
						required: true,
						class: PF.Field.String,
					},
					address: {
						class: PF.Field.String,
					},
					coords: {
						class: PF.Field.MapPoint,
					},
					// message_url: {
					// 	required: false,
					// 	key: "serverVa.message_url",
					// 	class: PF.Field.String,
					// },
					ip: {
						required: true,
						key: "serverVa.ip",
						class: PF.Field.Ip,
					},
					screens: {
						key: "serverVa.screens",
						class: PF.Field.ListCrud,
						listConfig: {
							title: 'Экраны',
							itemClass: Screen,
							modelsConfig: {
								represent: 'screen/manage',
								parentLink: { server_va_id: 'id' },
							},
						},
					},
					condition: {
						key: "serverVa.condition",
						class: PF.Field.Select,
						required: true,
						label: 'Состояние *',
						radioConfig: {
							listConfig: {
								modelsConfig: {
									raw: [
										{
											id: 'works',
											name: "Работает"
										},
										{
											id: 'сonfigurable',
											name: "Настраивается"
										},
										{
											id: 'disabled',
											name: "Отключена"
										},
										{
											id: 'dismantled',
											name: "Демонтирована"
										}
									]
								}
							},
						},
					},
					cameras: {
						key: "serverVa.cameras",
						class: PF.Field.ListCrud,
						listConfig: {
							title: 'Камеры',
							itemClass: Camera,
							modelsConfig: {
								represent: 'camera/manage',
								parentLink: { server_va_id: 'id' },
							},
						},
					},
					district: {
						class: PF.Field.Select,
						required: true,
						label: 'Выберите район *',
						radioConfig: {
							simpleName: '@{model.name}',
							dict: 'districts',
							listConfig: {
								searchConfig: ' @{name} ~ @{list.searchField}'
							},
						}
					}
				}
			}
		};
	}

	get itemInner()
	{
		//language=HTML
		return /*html*/`
		  <div class="item-inner">
			<div class="item-title">
				@{model.name}<br/>
				@{model.address} <br/>
				@{model.spisok}
			</div>
			<div class="item-after">
				<span>@{model.district.name}</span><br/>
				<span>@{model.serverVa.ip}</span><br/>
				<span pf="serverStatus"> @{model.serverVa.statusFormatted} @{model.serverVa.condition.name} </span>
			</div>
		  </div>
		`;
	}

	get formTemplate()
	{
		//language=HTML
		return `
		  <form pf="form">

			  <div class="block">
				  <input type="text" placeholder="Название *" pf="name">
				  <input type="text" placeholder="Адрес места установки" pf="address">
				  <div class="" pf="district"></div>
				  <div class="" pf="coords"></div>
			  </div>

			  <div class="block">
				  <input type="text" placeholder="IP *" pf="ip">
				  <!-- <input type="text" placeholder="Api Url" pf="message_url"> -->

				  <div class="" pf="condition"></div>
				  <p pf="statusBlock">Статус: @{model.statusFormatted}</p>
				  <p pf="tokenBlock">Токен доступа: @{model.serverVa.user.access_token}</p>

			  </div>
			  <div class="" pf="screens"></div>
			  <div class="" pf="cameras"></div>

			  <button class="button button-fill" pf="submit">Сохранить</button>
			  <div class="button button-fill" pf="config">Отправить новый конфиг</div><br>
		  </form>
		`;
	}

	init()
	{
		this.preInit();
		super.init();


		this.on('form-inited', () =>
		{
			this.bindDom({ tokenBlock: 'show' }, 'model.serverVa.user.access_token', (t) =>
			{
				return t !== undefined;
			});
			this.bindDom({ statusBlock: 'show' }, 'model.serverVa.status', (t) =>
			{
				return t !== undefined;
			});
		});

		if (this.model.get('serverVa.id', null, null) !== null) {
			this.temp = 'false';
		} else {
			this.temp = 'true';
		}
		this.bindDom({ config: 'show' }, 'temp', (s) => s === 'false');
		this.dom.config.on("click", (event) =>
		{
			this.model.setData('temp', 'temp');
			this.model.save();
			this.temp = 'true';
		});
	}


	onRender(event)
	{
		super.onRender(event);
		this.bindDom({ serverStatus: "css:color" }, 'model.serverVa.statusColor');
	};

	preInit()
	{

		let spisok = null;

		let serverVa = this.model.serverVa;
		for (let i = 0; i < serverVa.screens.length; i++)
		{
			if (serverVa.screens[i].name)
			{
				if (i == 0)
				{
					spisok = `"${serverVa.screens[i].name}"`;
				} else
				{
					spisok = spisok + `, "${serverVa.screens[i].name}"`;
				}
			}
		}
		for (let i = 0; i < serverVa.cameras.length; i++)
		{
			if (serverVa.cameras[i].name)
			{
				if (i == 0 && spisok == null)
				{
					spisok = `"${serverVa.cameras[i].name}"`;
				} else
				{
					spisok = spisok + `, "${serverVa.cameras[i].name}"`;
				}
			}
		}
		this.model.spisok = spisok;

		if (this.model.serverVa.condition !== undefined)
		{
			this.model.conditionFormatted = this.model.serverVa.condition.name;  // Состояние
		}

		if (this.model.get('serverVa.status', null, null) !== null && this.model.get('serverVa.status_detail', null, null) !== null)
		{
			let status = this.model.serverVa.status
			let status_detail = JSON.parse(this.model.serverVa.status_detail);
			if (status == '200')
			{
				this.model.statusFormatted = 'Работает ' + status_detail.dt;
			} else if (status == '400')
			{
				this.model.statusFormatted = 'На стеле обнаружены ошибки в работе ' + status_detail.dt + '<br>' + status_detail.detail;
			} else if (status == 'default' && this.model.serverVa.condition.id == 'works')
			{
				this.model.statusFormatted = 'Ожидается проверка после изменений';
			} else if (this.model.serverVa.condition.id == 'works')
			{
				this.model.statusFormatted = 'Не отвечает ' + status_detail.dt + '<br>' + status_detail.error;
			}
		}
	}

}

class Camera extends PF.ListCrud.Item
{
	get itemInner()
	{
		//language=HTML
		return `
		  <div class="item-inner">
			  <div class="item-title">
				  @{model.name}<br/>
			  </div>
			  <div class="item-after">
				  @{model.ip}
			  </div>
		  </div>
		`;
	}

	get formTemplate()
	{
		//language=HTML
		return `
		<form pf="form">
			<div class="block">
				<input type="text" pf="name"/>

				<input type="text" pf="stream"/>

				<input type="text" pf="web_stream"/>

				<input type="text" pf="ip"/>

				<div class="" pf="screen_id"></div>
			</div>
			<button class="button button-fill" pf="submit">Сохранить</button>
		</form>

		<div pf="cameraSnap">
			<button class="button-fill button" pf="cameraSnapButton">Получить снап с камеры</button>
			<div class="preloader-wrapper" pf="preloaderImg" style="width: fit-content; margin: auto;">
				<div class="preloader" style="margin:40px auto; ">
					<span class="preloader-inner">
						<span class="preloader-inner-gap"></span>
						<span class="preloader-inner-left">
							<span class="preloader-inner-half-circle"></span>
						</span>
						<span class="preloader-inner-right">
							<span class="preloader-inner-half-circle"></span>
						</span>
					</span>
				</div>
			</div>
			<div style="margin: 10px;" pf="cameraSnapImg"></div>
		</div>
		`;
	}

	static get options()
	{
		return {
			title: `@{model.name}`,
			newTitle: `Добавить камеру`,
			formConfig: {
				notModifyBehavior: 'hide',
				fieldsConfig: {
					name: {
						required: true,
						class: PF.Field.String,
						label: 'Название *',
					},
					ip: {
						class: PF.Field.Ip,
						required: false,
						label: 'ip',
					},
					stream: {
						class: PF.Field.String,
						required: true,
						label: '1 поток, для аналитики (h264) *',
					},
					web_stream: {
						class: PF.Field.String,
						required: false,
						label: '2 поток, для трансляции на портал (~mjpeg)',
					},
					screen_id: {
						key: "screen",
						class: PF.Field.Select,
						required: false,
						label: 'Выберите монитор, для которого фиксировать просмотры на этой камере',
						radioConfig: {
							dict: 'model.options.parent.parent.screens',
							simpleName: '@{model.name}',
							// listConfig: {
							//     modelsConfig: {
							//         represent: 'screen/manage',
							//     },
							// },
						}
					},
				}
			}
		};
	}

	init()
	{
		super.init();

		this.loadStatus = false;
		if ((this.model.options.parent.parent.ip !== null && this.model.options.parent.parent.ip !== undefined) && this.model.options.parent.parent.user_id !== undefined)
		{
			this.dom.cameraSnapImg.bindHtml();

			this.bindDom({ preloaderImg: 'show' }, 'loadStatus');

			this.dom.cameraSnapButton.on("click", (event) =>
			{
				this.dom.cameraSnapImg.html = ``;
				this.loadStatus = true;
				// this.dom.cameraSnapImg.html = `<img src='/img/lazy_loading.gif'>`;
				// this.dom.cameraSnapImg.html = '<img style="width: 100%;" src="' + '/camera/snap?id=' + this.model.id + '" alt="' + jis + '">';
				app.request('/camera/snap?id=' + this.model.id, [], (response) =>
				{
					if (response.status != 'FAIL')
					{
						this.dom.cameraSnapImg.html = response.data.img;
					} else
					{
						this.dom.cameraSnapImg.html = response.errorText;
					}
					this.loadStatus = false;
				}, () =>
				{
					this.dom.cameraSnapImg.html = `error`;
					this.loadStatus = false;
				});

			});
		}
		else
		{
			this.dom.cameraSnap.css('display', 'none');
		}
	}
}

class Screen extends PF.ListCrud.Item
{
	get itemInner()
	{
		//language=HTML
		return `
		  <div class="item-inner">
			  <div class="item-title">
				  @{model.name}<br/>
			  </div>
		  </div>
		`;
	}

	get formTemplate()
	{
		//language=HTML
		return `
		  <form pf="form">
			  <div class="block">
				  <input type="text" pf="name"/>
			  </div>
			  <button class="button button-fill" pf="submit">Сохранить</button>
		  </form>
		`;
	}

	static get options()
	{
		return {
			title: `@{model.name}`,
			newTitle: `Добавить экран`,
			formConfig: {
				notModifyBehavior: 'hide',
				fieldsConfig: {
					name: {
						class: PF.Field.String,
						label: 'Название',
					},
				}
			}
		};
	}

	destroy()
	{
		super.destroy();
	}
}